import { createElement } from 'react';
import { Box } from '../Box/Box.js';

const DrawerContainer = ({ children }) => {
    return (createElement(Box, { spacingH: { xs: 12, m: 32 }, spacingV: { xs: 8, m: 12 } }, children));
};

export { DrawerContainer };
//# sourceMappingURL=DrawerContainer.js.map
